import React, { useState, useMemo, useRef, useCallback } from 'react';

import { format } from 'date-fns';

import { Report } from '~/components';
import { Shifts } from '~/componentslocal';
import { Input, RadioGroup, Select } from '~/components/Form';

export default function DlgRelStatusOverFillAntesAbast() {
  const formRef = useRef(null);

  const [open, setOpen] = useState(true);
  const [toolbar, setToolbar] = useState({});

  const initialData = useMemo(
    () => ({
      datahorainicial: format(new Date(), 'dd/MM/yyyy 00:00:00'),
      datahorafinal: format(new Date(), 'dd/MM/yyyy 23:59:59'),
      ordenacaoRel: 'Posto',
      tanquecheioRel: 'todos',
      tipo: 'pdf',
    }),
    []
  );

  const optionsOrdenation = useMemo(
    () => [
      { label: 'Posto', value: 'Posto' },
      { label: 'Veículo', value: 'Veiculo' },
    ],
    []
  );

  const optionsTank = useMemo(
    () => [
      { label: 'Todos', value: 'todos' },
      { label: 'Sim', value: '170' },
      { label: 'Não', value: '180' },
    ],
    []
  );

  const optionsType = useMemo(
    () => [
      { label: 'PDF', value: 'pdf' },
      { label: 'Excel', value: 'xls' },
    ],
    []
  );

  const handleCloseReport = useCallback(() => {
    setOpen(false);
  }, []);

  const handleSerializeData = useCallback(
    (data) => {
      const { tank, station, initial, final } = toolbar;
      const { timVeiculo, tanquecheioRel, ordenacaoRel, tipo } = data;

      const formData = {
        post_cod_posto: tank,
        posto_str: station,
        turn_datahora_ini: initial,
        turn_datahora_fim: final,
        timVeiculo,
        tanquecheioRel,
        ordenacaoRel,
        tipo,
      };

      return formData;
    },
    [toolbar]
  );

  return (
    <Report
      ref={formRef}
      open={open}
      initials={initialData}
      title="Relatório Status Overfill Antes do Abastecimento"
      relatorio="REL_STATUS_OVERFILL_ANTES_ABASTECIMENTO"
      onClose={handleCloseReport}
      serialize={handleSerializeData}
    >
      <Shifts forms={formRef} onToolbar={(value) => setToolbar(value)} />

      <Input name="timVeiculo" label="Veículo" />

      <Select
        name="tanquecheioRel"
        label="Tanque Cheio"
        options={optionsTank}
      />

      <Select
        name="ordenacaoRel"
        label="Ordenação"
        options={optionsOrdenation}
      />

      <RadioGroup
        row
        name="tipo"
        label="Formato de Saída"
        options={optionsType}
      />
    </Report>
  );
}
